module.exports = __webpack_public_path__ + "static/media/fantest_question_3_3.b521491f.png";